import { MEMCACHIER_SUPPORT_URL } from "@/config/analytics/urls";

export const FLUSH_CACHE_ERROR = "Could not flush cache";
export const SWITCH_CLUSTER_ERROR =
  'Could not change cluster, please contact <a href="' + MEMCACHIER_SUPPORT_URL + '" target="_blank">support</a>';
export const RE_ENABLE_CACHE_SUCCESS = "Cache re-enabled! Refresh the page in about 1 minute.";
export const RE_ENABLE_CACHE_ERROR =
  'Could not re-enable cache, please contact <a href="' + MEMCACHIER_SUPPORT_URL + '" target="_blank">support</a>';
export const ROTATE_SSO_ERROR = "Could not rotate SSO";
export const PROCESSED_STATS_ERROR = "Could not fetch processed stats";
export const SETTINGS_ERROR = "Could not fetch settings";
export const FEATURES_ERROR = "Could not fetch features";
export const STATS_ERROR = "Could not fetch stats";
export const CREDENTIALS_FETCH_ERROR = "Could not fetch credentials";
export const CREDENTIALS_ADD_ERROR = "Could not create new credentials";
export const CREDENTIALS_REMOVE_ERROR = "Could not remove credentials";
export const CREDENTIALS_PROMOTE_ERROR = "Could not promote credentials";
export const CREDENTIALS_CAPABILITIES_ERROR = "Could not change capabilities";
export const ALERTS_ERROR = "Could not get alerts";
export const ALERT_ADD_ERROR = "Could not add alert";
export const ALERT_UPDATE_ERROR = "Could not update alert";
export const ALERT_REMOVE_ERROR = "Could not remove alert";
export const ALERTS_CONFIG_ERROR = "Could not get delivery destinations";
export const ALERT_CONFIG_ADD_ERROR = "Could not add delivery destination";
export const ALERT_CONFIG_REMOVE_ERROR = "Could not remove delivery destination";
export const SMTP_CONFIG_FETCH_ERROR = "Could not fetch SMTP settings";
export const TEST_EMAIL_ERROR = "Could not send test email";
export const TEST_EMAIL_SUCCESS = "Test email sent!";
export const SMTP_CONFIG_SET_ERROR = "Could not update SMTP settings";
export const TOGGLE_INTROSPECTION_ERROR = "Could not toggle Introspection";
export const LOGS_ERROR = "Could not get recent request logs";
export const SLAB_STATS_ERROR = "Could not get slab stats";
export const PROCESSED_SLAB_STATS_ERROR = "Could not get processed slab stats";
export const PREFIXES_ERROR = "Could not get prefixes";
export const PREFIX_POPULAR_ITEMS_ERROR = "Could not get prefix popular items";
export const PREFIX_STATS_ERROR = "Could not get prefix stats";
export const PREFIX_ADD_ERROR = "Could not add prefix";
export const PREFIX_REMOVE_ERROR = "Could not remove prefix";
export const COMPOUND_STATS_ERROR = "Could not get compound stats";
export const KEY_STATS_ERROR = "Could not get key stats";
export const CONSULTATION_REQUEST_SUCCESS = "Consultation request sent!";
export const CONSULTATION_REQUEST_ERROR = "Could not send consultation request";
export const LOGIN_ERROR = "Invalid login";

// CacheSight
export const PASSWORD_SUCCESS = "Password change successful!";
export const PASSWORD_ERROR = "Password could not be changed";
export const CACHE_ADD_ERROR = "Could not add cache";
export const CACHE_REMOVE_ERROR = "Could not remove cache";
export const CACHE_UPDATE_ERROR = "Could not update cache";
export const SERVER_REMOVE_ERROR = "Could not remove server";
export const SERVER_UPDATE_ERROR = "Could not add server";
